/**
 * AutoLinkModal - Vincular Imagens Automaticamente - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const AutoLinkModal = ({
  showAutoLinkModal,
  setShowAutoLinkModal,
  autoLinkImages,
  autoLinkLoading,
  autoLinkResult,
  setAutoLinkResult,
}) => {
  return (
      <Dialog open={showAutoLinkModal} onOpenChange={setShowAutoLinkModal}>
        <DialogContent className="glass-modal max-w-md">
          <DialogHeader>
            <DialogTitle className="text-white text-xl">Vincular Imagens</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4">
              <p className="text-sm text-gray-300">
                Esta função vincula automaticamente imagens da galeria aos produtos que não possuem imagem, 
                baseado em palavras-chave do nome e descrição.
              </p>
            </div>

            {autoLinkResult && (
              <div className={`rounded-xl p-4 ${autoLinkResult.linked > 0 ? 'bg-green-500/10 border border-green-500/20' : 'bg-yellow-500/10 border border-yellow-500/20'}`}>
                <p className={`text-sm font-semibold ${autoLinkResult.linked > 0 ? 'text-green-400' : 'text-yellow-400'} mb-2`}>
                  {autoLinkResult.linked > 0 ? '✓' : '⚠️'} {autoLinkResult.message}
                </p>
                {autoLinkResult.details && autoLinkResult.details.length > 0 && (
                  <div className="max-h-40 overflow-y-auto space-y-1 mt-2">
                    {autoLinkResult.details.map((item, i) => (
                      <p key={i} className="text-xs text-gray-400">
                        • {item.product} → {item.image} ({item.score}% match)
                      </p>
                    ))}
                  </div>
                )}
              </div>
            )}

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={() => {
                  setShowAutoLinkModal(false);
                  setAutoLinkResult(null);
                }}
                className="flex-1 px-4 py-3 text-base text-gray-400 hover:text-white transition-colors rounded-xl border border-gray-700 hover:border-gray-600"
                disabled={autoLinkLoading}
              >
                Fechar
              </button>
              <button
                onClick={autoLinkImages}
                disabled={autoLinkLoading}
                className="flex-1 glass-button-primary py-3 px-6 text-base font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {autoLinkLoading ? 'Vinculando...' : 'Vincular Agora'}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

  );
};

export default AutoLinkModal;
